import styled from 'styled-components';
import {Button} from 'antd';

const StyledAddExpenseButton = styled(Button)`
  .ant-wave {
    display: none !important;
  }

  & > * {
    display: flex;
  }

  &.ant-btn-primary {
    .ant-btn-icon {
      svg {
        height: 16px;
        width: 16px;
        path {
          stroke: ${props => props.theme.colors.primary_1};
        }
      }
    }
  }
`;

export {
  StyledAddExpenseButton,
};
